import { render, staticRenderFns } from "./ProductInfo.vue?vue&type=template&id=32727205"
import script from "./ProductInfo.vue?vue&type=script&lang=js"
export * from "./ProductInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports